import { useCallback } from 'react';
import { useAppSelector } from '../store/hooks';
import { gleapService } from '../services/api/gleap-service';
import { selectAppSettings } from '../features/common/app-settings/app-settings-slice';
import { selectUserProfile } from '../features/common/auth/auth-slice';

export const useGleap = () => {
  const settings = useAppSelector(selectAppSettings);
  const userProfile = useAppSelector(selectUserProfile);

  const initGleap = useCallback(() => {
    if (settings) {
      gleapService.initGleap(settings);
    }
  }, [settings]);

  const identifyGleapUser = useCallback((username?: string, grmUserId?: string, email?: string) => {
    if (settings) {
      const finalUsername = username || userProfile?.name || '';
      const finalGrmUserId = grmUserId || userProfile?.username || '';
      const finalEmail = email || userProfile?.username || '';
      
      gleapService.identifyGleapUser(settings, finalUsername, finalGrmUserId, finalEmail);
    }
  }, [settings, userProfile]);

  const clearAndCloseGleap = useCallback(() => {
    if (settings) {
      gleapService.clearAndCloseGleap(settings);
    }
  }, [settings]);

  const isGleapInitialized = gleapService.isInitialized();

  const startSnapshotForm = useCallback((customerName: string) => {
    if (settings) {
      return gleapService.startSnapshotForm(settings, customerName);
    }
    console.warn('Gleap settings not loaded');
    return Promise.resolve([]);
  }, [settings]);

  const getTicketsByUserId = useCallback((userId: string) => {
    if (settings) {
      return gleapService.getTicketsByUserId(userId, settings);
    }
    console.warn('Gleap settings not loaded');
    return Promise.resolve([]);
  }, [settings]);

  const getTicketInfoById = useCallback((ticketId: string) => {
    if (settings) {
      return gleapService.getTicketInfoById(ticketId, settings);
    }
    console.warn('Gleap settings not loaded');
    return Promise.resolve(null);
  }, [settings]);

  return {
    initGleap,
    identifyGleapUser,
    clearAndCloseGleap,
    isGleapInitialized,
    startSnapshotForm,
    getTicketsByUserId,
    getTicketInfoById
  };
};
